"use client";
import { useUpdateEffect } from "@ariakit/react-utils";
import { useStore, useStoreProps } from "@ariakit/react-store";
import * as Core from "@ariakit/components/disclosure/disclosure-store";
//#region src/disclosure/disclosure-store.ts
function useDisclosureStoreProps(store, update, props) {
	useUpdateEffect(update, [props.store, props.disclosure]);
	useStoreProps(store, props, "open", "setOpen");
	useStoreProps(store, props, "mounted", "setMounted");
	useStoreProps(store, props, "animated");
	return Object.assign(store, { disclosure: props.disclosure });
}
/**
* Creates a disclosure store to control the state of
* [Disclosure](https://ariakit.com/components/disclosure) components.
* @see https://ariakit.com/components/disclosure
* @example
* ```jsx
* const disclosure = useDisclosureStore();
*
* <Disclosure store={disclosure}>Disclosure</Disclosure>
* <DisclosureContent store={disclosure}>Content</DisclosureContent>
* ```
*/
function useDisclosureStore(props = {}) {
	const [store, update] = useStore(Core.createDisclosureStore, props);
	return useDisclosureStoreProps(store, update, props);
}
//#endregion
export { useDisclosureStore, useDisclosureStoreProps };

//# sourceMappingURL=disclosure-store.js.map